import React from 'react';
import styled from 'styled-components';

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px auto;
  -webkit-font-smoothing: antialiased;

  .account__active,
  .transaction__active,
  .gts_transaction__active {
    // transform: scale(1.15);
    background: #181818 !important;
    color: white !important;
    border: none !important;
  }

  .btn {
    // box-sizing: border-box;
    border-radius: 100px;
    cursor: pointer;
    font-family: 'GT', sans-serif;
    font-feature-settings: 'ss03' on;
    font-weight: 500;
    letter-spacing: 0.04em;
    // outline: none;
    font-size: 16px;
    height: 40px;
    line-height: 24px;
    padding-left: 15px;
    padding-right: 15px;
    background-color: white;
    color: #181818;
    margin: auto 10px;
    border: 1px solid grey;
  }
`;

export default function ThresholdsButton(props) {
  const { buttonClickHandler, configName } = props;

  return (
    <ButtonGroup>
      <button
        onClick={buttonClickHandler}
        className={`btn ${configName === 'account' ? 'account__active' : ''}`}
      >
        Account
      </button>
      <button
        onClick={buttonClickHandler}
        className={`btn ${
          configName === 'transaction' ? 'transaction__active' : ''
        }`}
      >
        Transaction
      </button>
      <button
        onClick={buttonClickHandler}
        className={`btn ${
          configName === 'gts_transaction' ? 'gts_transaction__active' : ''
        }`}
      >
        GTSnet
      </button>
    </ButtonGroup>
  );
}
